module.exports = __webpack_public_path__ + "img/Monterey Bay Aquarium depth.2d94c689.jpg";